import * as React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Field } from 'formik'
import {
  TidalPhoneFieldFormik,
  TidalTextFormikField,
} from '@sales-center/components'

export function TypeCommonFields() {
  return (
    <>
      <Typography variant="h7">Select Default Values (Optional)</Typography>
      <Typography mb={1.6} variant="body1">
        If one of your rows is missing a value, the following defaults will be
        applied.
      </Typography>
      <Grid container spacing={1} mb={2}>
        <Grid item xs md>
          <TidalTextFormikField
            name="firstName"
            label="First Name"
            inputProps={{ maxLength: 15 }}
          />
        </Grid>
        <Grid item xs md>
          <TidalTextFormikField
            name="lastName"
            label="Last Name"
            inputProps={{ maxLength: 20 }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TidalTextFormikField
            name="companyName"
            label="Company Name"
            inputProps={{ maxLength: 35 }}
          />
        </Grid>
        <Grid item xs={8}>
          <Field
            name={'phoneNumber'}
            label="Phone"
            component={TidalPhoneFieldFormik}
          />
        </Grid>
        <Grid item xs={4}>
          <TidalTextFormikField
            name="phoneExt"
            label="Ext"
            inputProps={{
              type: 'number',
              onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 5)
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TidalTextFormikField
            name="emailAddress"
            label="Email Address"
            inputProps={{ type: 'email', maxLength: 200 }}
          />
        </Grid>
      </Grid>
    </>
  )
}
